import { useEffect, useState } from 'react'

const ColorMode = ({ className = 'btn btn-sm d-none d-md-block' }) => {
  const [dark, setDark] = useState(() => {
    const savedMode = localStorage.getItem('darkmode')
    return savedMode ? JSON.parse(savedMode) : false
  })

  useEffect(() => {
    // Nastaví atribut na <html> podle stavu
    document.documentElement.setAttribute('data-bs-theme', dark ? 'dark' : 'light')
  }, [dark])

  const handleColorMode = () => {
    setDark(prevMode => {
      const newMode = !prevMode
      localStorage.setItem('darkmode', JSON.stringify(newMode))
      return newMode
    })
  }

  return (
    <button
      onClick={handleColorMode}
      title={dark ? 'Světlý režim' : 'Tmavý režim'}
      className={className}
    >
      {dark ? <i className="bi bi-sun"></i> : <i className="bi bi-moon-stars"></i>}
    </button>
  )
}

export default ColorMode
